import { TextField, Tooltip } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React, { useContext, useEffect, useState } from "react";
import Heading from "../../../Components/Heading/Heading";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import "./ResourceCapacity.css";
import moment from "moment";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  ExportToExcelResourceCapacity,
  GetDropDownList,
  GetResourceCapacityData,
} from "../../../Helpers/API/APIEndPoints";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { LoaderContext } from "../../../Helpers/Context/Context";
import axios from "axios";
import fileDownload from "js-file-download";
import notify from "../../../Helpers/ToastNotification";
import { Button } from "react-bootstrap";

const ResourceCapacity = () => {
  const [date, setDate] = useState<Date | null>(
    moment().startOf("month").toDate()
  );
  const [month, setMonth] = useState(
    moment().startOf("month").toDate().getMonth()
  );
  const [year, setYear] = useState<any>(
    moment().startOf("month").toDate().getFullYear()
  );
  const [costCenterOptions, setCostCenterOptions] = useState([]);
  const [costCenterSelectData, setCostCenterSelectData] = useState([]);
  const [gridData, setGridData] = useState([]);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [reset, setReset] = useState(false);
  const [load, setLoad] = useState(false);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  useEffect(() => {
    GetCostCenterOptions();
  }, []);

  const GetCostCenterOptions = async () => {
    let postObject = {
      searchFor: "costCenter",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data !== null) {
      let options = [];
      data.map((item, index) => {
        options.push({ value: item.value, label: item.label, id: item.value });
      });
      options.sort((a, b) => a.label.localeCompare(b.label));
      setCostCenterOptions(options);
    }
  };

  useEffect(() => {
    if (reset) {
      setLoad(false);
    }
  }, [reset]);

  useEffect(() => {
    (async () => {
      if (load) {
        await GetGridData();
        setLoad(false);
      }
    })();
  }, [sortDirection, sortColumn, searchText, start, pageSize, reset]);

  const ConvertArrayToString = (arr) => {
    let s = [];
    arr.map((i) => s.push(i.value));
    return s.join(",");
  };

  const GetGridData = async () => {
    let costcenterId = ConvertArrayToString(costCenterSelectData);
    showLoader();
    let requestObj = {
      Month: months[month],
      Year: year,
      start: start,
      pageSize: pageSize,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      searchText: searchText,
      CostCenterId: costcenterId,
    };
    const { data } = await APICall(GetResourceCapacityData, "POST", requestObj);
    //console.log(data)
    if (data != null) {
      setGridData(data.data);
      setCount(data.count);
    }
    hideLoader();
  };

  const SelectOnChange = (e, apiField) => {
    if (apiField === "Year&Month") {
      setDate(e);

      const mm = moment(e).toDate().getMonth();

      const yyyy = moment(e).toDate().getFullYear();

      setMonth(mm);
      setYear(yyyy);
    }
    if (apiField === "costCenter") {
      setCostCenterSelectData(e);
    }
    // const startOfMonth = moment(e)
    //   .clone()
    //   .startOf("month")
    //   .format("YYYY-MM-DD");
    // const endOfMonth = moment(e).clone().endOf("month").format("YYYY-MM-DD");
  };

  const submitFunc = async (apiField) => {
    if (apiField === "submit") {
      setLoad(true);
      setReset(!reset);
      return;
    }

    if (apiField === "reset") {
      setLoad(false);
      setMonth(moment().startOf("month").toDate().getMonth());
      setYear(moment().startOf("month").toDate().getFullYear());
      setCostCenterSelectData([]);
      setDate(moment().startOf("month").toDate());
      setReset(!reset);
    }
  };

  const ExportToExcel = () => {
    let costcenterId = ConvertArrayToString(costCenterSelectData);
    let obj = {
      Month: months[month],
      Year: year,
      sortColumn,
      sortDirection,
      searchText,
      pageSize: count,
      CostCenterId: costcenterId,
      start: 0,
    };
    axios
      .request({
        responseType: "blob",
        method: "POST",

        //data: Response,
        url: ExportToExcelResourceCapacity,
        //data:JSON,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: obj,
      })
      .then((response) => {
        fileDownload(response.data, "ResourceCapacity.xlsx");
      })
      .catch((error) => {
        notify(1, "Something went wrong");
      });
  };

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
      setLoad(true);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      setLoad(true);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
      setLoad(true);
    },
  };
  const gridColumns = [
    { name: "name", label: "Resource" },
    { name: "efficiency", label: "Efficiency" },
    { name: "reportingManager", label: "Reporting Manager" },
    { name: "costCenter", label: "Vertical" },
    {
      name: "workingDay",
      label: "Working Day",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "plannedTM",
      label: "Planned T&M",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "plannedAMC",
      label: "Planned AMC",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "plannedProject",
      label: "Planned Project",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "plannedProduct",
      label: "Planned Product",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "plannedInternal",
      label: "Planned Internal",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },

    {
      name: "plannedInefficient",
      label: "Planned Inefficient",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },

    {
      name: "plannedLeaves",
      label: "Leaves",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },

    {
      name: "plannedTotal",
      label: "Planned Total",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "spare",
      label: "Spare",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },

    {
      name: "actualTM",
      label: "Actual T&M",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "actualAMC",
      label: "Actual AMC",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "actualProject",
      label: "Actual Project",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "actualProduct",
      label: "Actual Product",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "actualInternal",
      label: "Actual Internal",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "inefficient",
      label: "Actual Inefficient",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "actualLeaves",
      label: "Leaves",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "nonChargeable",
      label: "Non Chargeable",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "actualTotal",
      label: "Actual Total",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "actualSpare",
      label: "Spare",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "variance",
      label: "Variance",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
  ];

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading title={"Resource Capacity"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-end gap-2">
              <button
                onClick={() => ExportToExcel()}
                className="btn btn-export"
              >
                Export to Excel
              </button>
              <a className="filterIcon" onClick={toggleFilter}>
                <i className="fa fa-filter"></i>
              </a>
            </div>
          </div>
          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Date</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        views={["year", "month"]}
                        label="Year and Month"
                        value={date}
                        onChange={(e) => {
                          SelectOnChange(e, "Year&Month");
                        }}
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Vertical</label>
                    <SelectForm
                      value={costCenterSelectData}
                      onChange={(e) => SelectOnChange(e, "costCenter")}
                      options={costCenterOptions}
                      isMulti
                      isSearchable={false}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      placeholder="Select Vertical"
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      onClick={() => submitFunc("reset")}
                      className="btn btn-reset"
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => submitFunc("submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={options}
              columns={gridColumns}
              data={gridData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ResourceCapacity;
